import React from 'react'
import {
  SecuredComponent as BaseSecuredComponent,
  UnAuthorized,
} from '@integec/common-react-screens/lib/auth'
import LoginScreen from 'core/component/LoginScreen'
import { connect } from 'react-redux'
import { getSecurityInfo } from 'core/selectors'
import { userManager } from '../oidc-support/utils'
import OidcAuthenticated from '../oidc-support/OidcAuthenticated'
import { getMetaConfig } from 'utils'

const useMisoF5 = getMetaConfig('misoF5Auth', 'false') === 'true'
console.log('miso f5 auth', useMisoF5)

const SecuredComponent = connect(getSecurityInfo)(props => (
  <BaseSecuredComponent {...props} app="pgads" />
))

const renderLogin = () => <LoginScreen />
const renderUnAuthorized = () => <UnAuthorized />

export const LoginWhenUnAuthorized = props => {
  if (useMisoF5) return props.children
  // console.log('secure component props', props)
  if (userManager != null) return <OidcAuthenticated {...props} />
  return (
    <SecuredComponent {...props} renderUnAuthorized={renderLogin} isGodMode />
  )
}

export const HideWhenUnAuthorized = props =>
  useMisoF5 ? props.children : <SecuredComponent {...props} />
export const WarnWhenUnAuthorized = props =>
  useMisoF5 ? (
    props.children
  ) : (
    <SecuredComponent
      {...props}
      renderUnAuthorized={renderUnAuthorized}
      isGodMode
    />
  )
